<template>
  <div class="att-header pt-3 pb-2">
    <template v-for="(item, index) in menulist">
      <p
        :key="index"
        :class="{ active: pathName == item.path }"
        @click="changeMenu(item.path)"
      >
        {{ item.name }}
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name:'attHeader',
  data() {
    return {
      pathName: this.$route.name,
      menulist: [
        { name: "团队统计", path: "team", show: true },
        { name: "我的月历", path: "attendence", show: true },
      ],
    };
  },
  created() {},
  methods: {
    changeMenu(name) {
      if (this.$route.name == name) return;
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.att-header {
  @include flex-center();
  & > p {
    width: 50%;
    font-size: 36px;
    font-family: SimHei;
    font-weight: 400;
    color: #999999;
    cursor: pointer;
    text-align: center;
  }
  & > p:nth-child(1) {
    border-right: 1px solid #dedede;
  }
  & > .active {
    font-size: 36px;
    font-family: SimHei;
    font-weight: 500;
    color: #3a86f4;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      bottom: -16px;
      left: 50%;
      transform: translateX(-50%);
      width: 61px;
      height: 5px;
      background: #3a86f4;
      border-radius: 2px;
    }
  }
}
</style>